
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/venda-seu-veiculo",
      function () {
        return require("private-next-pages/venda-seu-veiculo/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/venda-seu-veiculo"])
      });
    }
  